import React, {useState} from "react";
import {Input, Button, Table, DatePicker, Select, TimePicker, Popconfirm, Pagination} from "antd";

import locale from 'antd/es/date-picker/locale/zh_CN';

import {SearchOutlined} from '@ant-design/icons';


import './index.sass'
import {Link} from "react-router-dom";
import api from "../../utils/api";
import UserInfo from "../../components/UserInfo";
import qs from "../../utils/qs";
import {Base64} from "js-base64";
import {MERCHANT_STATE} from "../../store/merchant";
import {TOKEN_STATE} from "../../store/token";
import {connect} from "react-redux";


const {RangePicker} = DatePicker;
const {Option} = Select;
class GroupsList extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            change_fans_flag: 0,
            dataSource: [],
            page: 1,
            total: 0,
            status: '',
            team_name: '',//团购名称
            supplier_name: '',//所属供应商
            arrival_date: '',//到货时间
            end_time: '',//截团时刻
            tongji: {
                total_amount: 0,
                contract_num: 0,
                gb_num: 0
            },
            change_buy_flag: 0,//
            sale_types: [{name: '团购', val: ''}],
            provide_types: [{name: '合约', val: ''}],
            referable: false
        }
    }
    componentDidMount () {
        this.searchList();
        this.getSumOrderAmount();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.token.value && nextProps.token.value !== this.props.token.value) {
            this.searchList();
            this.getSumOrderAmount();
        }
        return true;
    }

    change_fans_type = (flag) => {

        this.setState({
            change_fans_flag: flag
        })
    }

    change_buy_type = (flag) => {

        this.setState({
            change_buy_flag: flag,
            referable: flag > 0
        })
    }


    getSumOrderAmount = async () => {//获取后台首页销售总金额

        let res = await api('sum-order-amount-by-merchant');
        if (res.code === 200) {
            let state = {...this.state};
            state.tongji = res.data;
            this.setState(state);
        }
    }

    getGbList = async (page = 1, sql) => {//获取团购列表

        this.setState({
            page
        })

        let param = {
            page,
            page_size: 15
        }

        if (sql) {
            param['search'] = sql.search
        }

        let res = await api('gb-list', param)

        if (res.code === 200) {
            this.setState({
                dataSource: res.data,
                total: res.meta.paginate.total_count
            })
        }
    }
    code;

    pauseGb = async (ctx, boolean) => {// 暂停/开启团购

        let param = {
            gb_id: ctx.id
        }

        let res = null

        res = boolean ? await api('pause-gb', param) : await api('resume-gb', param);

        if (res['code'] === 200) {
            await this.getGbList();
        }
    }


    searchList = (page = 1) => {

        let {team_name, supplier_name, status, arrival_date, end_time, referable} = this.state;
        let sqlarr = [
            {name: 'referable', val: referable},
            {name: 'team_name', val: team_name},
            {name: 'supplier_name', val: supplier_name},
            {name: 'status', val: status},
            {name: 'arrival_date', val: arrival_date},
            {name: 'end_time', val: end_time},
        ];

        let sql = qs.sqlSearch(sqlarr);

        let {search} = sql;

        search = Base64.encode(JSON.stringify(search));

        sql.search = search;

        this.getGbList(page, sql);
    }

    render () {
        let {
            change_fans_flag,
            dataSource,
            page,
            total,
            tongji,
            change_buy_flag,
        } = this.state;
        const columns = [
            {
                title: '合约标题',
                width: 100,
                render: (ctx) => {
                    return (
                        <p className='oneLine width100'>{ctx.name}</p>
                    )
                }
            },
            {
                title: '所属供应商',
                width: 100,

                render: (ctx) => {
                    return (
                        <p className='oneLine width100'>{ctx.creator.name}</p>
                    )
                }
            },
            {
                title: '团购时间',
                width: 170,
                render: (ctx) => {
                    return (
                        ctx.settings.batches.map((v, i) => <p
                            className='oneLine width150'>{v.start_time + '~' + v.end_time}</p>
                        )
                    )
                }
            },
            {
                title: '到货时间',
                width: 150,

                render: (ctx) => {
                    return (
                        ctx.settings.batches.map((v, i) => <p className='oneLine width150'>{v.arrival_date}</p>
                        )
                    )
                }
            },
            {
                title: '团购状态',
                width: 100,
                render: (ctx) => {
                    return (
                        ctx.settings.batches.map((v, i) => <p
                            className='oneLine width100'>{qs.groupStatus(v.status)}</p>
                        )
                    )
                }
            },
            {
                title: '截团时间',
                width: 150,
                render: (ctx) => {
                    return (
                        ctx.settings.batches.map((v, i) => <p className='oneLine width150'>{v.end_time}</p>
                        )
                    )
                }
            },
            {
                title: '返佣比例',
                width: 100,
                render: (ctx) => {
                    return (
                        ctx.settings.batches.map((v, i) => <p
                            className='oneLine width100'>{v.contract_stat ? v.contract_stat.commission_amount : 0}</p>
                        )
                    )
                }
            },
            {
                title: '总销售额',
                width: 150,
                render: (ctx) => {
                    return (
                        <p className='oneLine width150'>
                            ￥ {ctx.contract_stat ? (ctx.contract_stat.sales_amount) : ctx.gb_stat ? (ctx.gb_stat.sales_amount) : 0}
                        </p>
                    )
                }
            },
            {
                title: '佣金',
                width: 100,
                render: (ctx) => {
                    return (
                        <p className='oneLine width100'>
                            ￥ {ctx.contract_stat ? (ctx.contract_stat.commission_amount) : ctx.gb_stat ? (ctx.gb_stat.commission_amount) : 0}
                        </p>
                    )
                }
            },
            {
                title: '操作',
                width: 150,
                fixed: 'right',
                key: 'id',
                render: (ctx, record, index) => {
                    return (
                        <div className='flex width150'>
                            <Link className='mgr10' to={'/group/groupsDetail?id=' + ctx['id']}>查看详情</Link>

                            {
                                this.state.change_fans_flag === 1 ? ctx.allow ? (

                                    <Popconfirm
                                        title='确定不允许退款？'
                                        onConfirm={() => {
                                            ctx.allow = false;
                                            this.state.dataSource[index]['allow'] = false
                                        }}
                                        okText='yes'
                                        cancelText='no'
                                    >
                                        <div className='mgr10 pointer themeColor'>允许退款</div>
                                    </Popconfirm>
                                ) : (
                                    <Popconfirm
                                        title='确定允许退款？'
                                        onConfirm={() => {
                                            ctx.allow = true;
                                            this.state.dataSource[index]['allow'] = true
                                        }}
                                        okText='yes'
                                        cancelText='no'
                                    >
                                        <div className='mgr10 pointer warn'>不允许退款</div>
                                    </Popconfirm>
                                ) : null
                            }

                            {
                                !ctx.pause ? (<Popconfirm
                                    title="确定暂停该团购？"
                                    okText="确定"
                                    cancelText="取消"
                                    onConfirm={() => {
                                        this.pauseGb(ctx, true)
                                    }}
                                >

                                    <Button size='small' danger>暂停</Button>
                                </Popconfirm>) : (<Popconfirm
                                    title="确定开启该团购？"
                                    okText="确定"
                                    cancelText="取消"
                                    onConfirm={() => {
                                        this.pauseGb(ctx, false)
                                    }}
                                >

                                    <Button size='small' type="primary">开启</Button>
                                </Popconfirm>)
                            }
                        </div>
                    )
                }
            },
        ];

        function handleChange () {
        }

        const HeaderRight = () => {
            let [tongji] = useState(this.state.tongji);
            return <ul className='flex census' token={this.props.token.value}>
                <li>
                    <label>进行中的团购</label>
                    <p>{tongji['gb_num']}</p>
                </li>
                <li>
                    <label>进行中的合约</label>
                    <p>{tongji['contract_num']}</p>
                </li>
                <li>
                    <label>今日总销售额</label>
                    <p>￥{tongji['total_amount']}</p>
                </li>
            </ul>
        }

        return (
            <div className='groupsList'>
                {/* 头部 */}
                <UserInfo rightBox={<HeaderRight tongji ={tongji}/>}
                />

                <div className='record'>
                    <div className='change_fans'>
                        <ul className='flex tabs'>
                            <li className={change_buy_flag === 0 ? 'active' : ''} onClick={() => {
                                this.change_buy_type(0)
                            }}>我帮卖的
                            </li>
                            <li className={change_buy_flag === 1 ? 'active' : ''} onClick={() => {
                                this.change_buy_type(1)
                            }}>我供货的
                            </li>
                        </ul>
                    </div>
                    <div className='change_fans flex'>
                        {
                            !change_buy_flag ? (
                                <div className='flex line alignCenter mgr10'>
                                    帮卖类型：
                                    <Select
                                        defaultValue="1"
                                        style={{
                                            width: 120,
                                        }}
                                        onChange={handleChange}
                                    >
                                        <Option value="1">团购</Option>
                                    </Select>
                                </div>
                            ) : (
                                <div className='flex line alignCenter mgr10'>
                                    供货类型：
                                    <Select
                                        defaultValue="1"
                                        style={{
                                            width: 120,
                                        }}
                                        onChange={handleChange}
                                    >
                                        <Option value="1">合约</Option>
                                    </Select>
                                </div>
                            )
                        }
                        <div className='flex line alignCenter mgr10'>
                            团购标题：
                            <Input onChange={(e) => {
                                this.setState({team_name: e.target.value})
                            }} placeholder='团购标题：'/>
                        </div>
                        <div className='flex line alignCenter mgr10'>
                            {
                                change_fans_flag === 0 ? '所属供应商：' : '所属渠道：'
                            }

                            <Input onChange={(e) => {
                                this.setState({supplier_name: e.target.value})
                            }} placeholder='所属供应商/所属渠道'/>
                        </div>

                        <div className='flex line alignCenter mgr10'>
                            团购状态：
                            <Select
                                placeholder="全部"
                                optionFilterProp="children"
                                onChange={(val) => {
                                    console.log(val);
                                    this.setState({status: val})
                                }}
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                <Option value="">全部</Option>
                                <Option value="WAIT">等待编辑发布</Option>
                                <Option value="RUNNING_WAIT_SUCCESS">进行中待成团</Option>
                                <Option value="RUNNING_SUCCESS">进行中已成团</Option>
                                <Option value="END_SUCCESS">已结束已成团</Option>
                                <Option value="END_FAILED">已结束未成团（失败）</Option>
                                <Option value="WAIT_PUBLISH">等待审核发布</Option>
                                <Option value="RUNNING">进行中</Option>
                                <Option value="END">已结束</Option>

                            </Select>
                        </div>

                        <div className='flex line alignCenter mgr10'>
                            到货时间：
                            <RangePicker onChange={(e, d) => {
                                this.setState({arrival_date: d.join('~')})
                            }} locale={locale}/>
                        </div>

                        <div className='flex line alignCenter mgr10'>
                            截团时刻：
                            <TimePicker.RangePicker onChange={(e, d) => {
                                this.setState({end_time: d.join('~')})
                            }} locale={locale} style={{width: 200}} format={'HH:mm'}/>
                        </div>

                        <Button onClick={() => {
                            this.searchList()
                        }} className='mgr10 themeBtn' icon={<SearchOutlined/>}>搜索</Button>

                        <Button className='mgr10'>重置</Button>

                    </div>


                    <div className='change_fans'>
                        <Table pagination={false} dataSource={dataSource} columns={columns} scroll={
                            {
                                scrollToFirstRowOnChange: false,
                                x: false
                            }
                        }/>
                    </div>


                    <div className='page_style'>
                        <Pagination
                            page_size={15}
                            hideOnSinglePage={true}
                            onChange={(e) => {
                                this.getGbList(e)
                            }}
                            defaultCurrent={1} showSizeChanger={false}
                            current={page}

                            total={total}/>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (store) => {
    return {
        merchant: store[MERCHANT_STATE],
        token: store[TOKEN_STATE]
    }
};
export default connect(mapStateToProps)(GroupsList);